export default __webpack_public_path__ + "static/media/tg.23a4a972.svg";